import React, { Component } from 'react';
import { connect } from 'react-redux';
import LegalEntityForm from './LegalEntityForm';
import ExistingLegalEntities from './ExistingLegalEntities';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import LIVE_REPORTING_CONTROLLER from '../../controllers/liveReporting';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('LIVE_REPORTING_SETUP', LOG_LEVELS.DEBUG);

class LiveReportingSetup extends Component {

  constructor(props) {
    super(props);
    this.onCellEditDone = this.onCellEditDone.bind(this);
    this.onCellDeleteDone = this.onCellDeleteDone.bind(this);
    this.onLegalEntityAddDone = this.onLegalEntityAddDone.bind(this);
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount() ');
    this.props.doPageLoad();
  }

  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();
  }

  onLegalEntityAddDone() {
    this.props.doPageLoad();
  }

  onCellEditDone() {
    this.props.doPageLoad();
  }

  onCellDeleteDone() {
    this.props.doPageLoad();
  }
  
  render() {
    log.debug('render(): ', this.props);
    const legalEntities = this.props.legalEntities || [];
    const legalEntitiesRows = legalEntities.map((entry) => {
      return {
        TaxNumber: entry.taxNumber || '',
        SellerName: entry.sellerName || '',
        Login: entry.login || '',
        Password: entry.password || '',
        XMLSignatureKey: entry.xmlSignatureKey || '',
        XMLExchangeKey: entry.xmlExchangeKey || '',
        SendingEnabled: true
      };
    });

    return (
      <div className="content-area">
        <s-container>
          <h1><LanguageStringResolver string="liveReportingSetup_LiveReportingSetup"></LanguageStringResolver></h1>
          <ExistingLegalEntities data={legalEntitiesRows} 
                onCellEditDone={this.onCellEditDone}
                onCellDeleteDone={this.onCellDeleteDone} /> 
          <hr />
          <h2><LanguageStringResolver string="liveReportingSetup_CreateLegalEntity"></LanguageStringResolver></h2>
          <s-row>
            <s-col span="6">
              <LegalEntityForm 
                onAddDone={this.onLegalEntityAddDone.bind(this)} 
                legalEntity={
                  {"login":"","password":"","taxNumber":"","xmlSignatureKey":"","xmlExchangeKey":"","sellerName":""}
                } />
            </s-col>
          </s-row>
        </s-container>
      </div>
    );
  }
}



// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);

  return {
    languages: state.languages,
    legalEntities: (state.liveReporting && state.liveReporting.leaglEntities) || []
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doPageLoad: (params) => {
        dispatch(LIVE_REPORTING_CONTROLLER.doGetLegalEntities(params));
    }
  }
}

export default  authorize({
  name: 'LiveReportingSetup',
  resource: connect(mapStateToProps, mapDispatchersToProps)(LiveReportingSetup)
}, AuthorizedResource, {
  showNotAuthorized: true
});
